var searchlabelbox = require("../modules/searchlablebox")
searchlabelbox.init("search-label-input","search-result-div","enter-label")